import { siteConfig } from '../../../shared/config/site';
import { scrollToTop } from '../../../shared/lib/scroll';

export function FooterSection() {
  return (
    <footer className="defer-render border-t border-neutral-200 bg-surface px-[var(--section-padding-x)] py-14 pb-32 lg:pb-14">
      <div className="mx-auto flex max-w-[var(--container-max)] flex-col gap-10 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <button
            type="button"
            onClick={scrollToTop}
            className="inline-flex min-h-11 items-center font-display text-2xl font-semibold text-ink"
          >
            {siteConfig.shortName}
          </button>
          <p className="mt-2 font-display text-accent-600">Veterinary Clinic</p>
          <p className="mt-4 max-w-[46ch] font-body text-base leading-7 text-neutral-600">{siteConfig.footerDescription}</p>
        </div>

        <div className="font-body text-base leading-7 text-neutral-600">
          <p className="text-ink">{siteConfig.addressLine}</p>
          <p className="mt-3">
            <a href={siteConfig.phoneHref} className="inline-flex min-h-11 items-center text-neutral-700 transition-colors duration-200 ease-in-out hover:text-primary-600">
              {siteConfig.phoneDisplay}
            </a>
            {' · '}
            <a href={siteConfig.emailHref} className="inline-flex min-h-11 items-center text-neutral-700 transition-colors duration-200 ease-in-out hover:text-primary-600">
              {siteConfig.email}
            </a>
          </p>
          <p className="mt-3">
            {siteConfig.ratingValue} ★ · {siteConfig.reviewCount} Google reviews
          </p>
        </div>
      </div>
    </footer>
  );
}
